
(function(){
  'use strict';

  // Scope every lookup to THIS section's root so multiple instances / theme
  // globals never collide. Redirect target is a section setting (Liquid → JS).
  var ROOT = document.getElementById('fhq-template--27637340832025__quiz');
  if (!ROOT) return;
  var q = function(sel){ return ROOT.querySelector(sel); };
  var qa = function(sel){ return ROOT.querySelectorAll(sel); };

  const sections = qa('section.q');
  const totalSections = new Set(Array.from(sections).map(s => parseInt(s.dataset.type, 10))).size;

  // ─────────── BRANCHING: skip sections whose data-show-if doesn't match Q2 pains ───────────
  function isSectionActive(num) {
    const sec = q('section.q[data-type="' + num + '"]');
    if (!sec) return false;
    const showIf = sec.dataset.showIf;
    if (!showIf) return true;
    const required = showIf.split(',').map(s => s.trim());
    const pains = Array.isArray(answers.q2) ? answers.q2 : [];
    return required.some(p => pains.includes(p));
  }

  // ─────────── INJECT QUESTION COUNTERS (dynamic per user path) ───────────
  const QUESTION_TYPES = [0, 1, 2, 3, 4, 5, 6, 8, 9, 11, 12, 13, 14];
  QUESTION_TYPES.forEach(type => {
    qa('section.q[data-type="' + type + '"]').forEach(sec => {
      const title = sec.querySelector('.q-title');
      if (!title || sec.querySelector('.q-counter')) return;
      const counter = document.createElement('div');
      counter.className = 'q-counter';
      counter.textContent = ''; // filled at section enter
      title.parentNode.insertBefore(counter, title);
    });
  });
  function updateQuestionCounter(num) {
    // Count how many user questions are active given current answers
    const active = QUESTION_TYPES.filter(t => isSectionActive(t));
    const total = active.length;
    const idx = active.indexOf(num);
    if (idx === -1) return;
    qa('section.q[data-type="' + num + '"] .q-counter').forEach(el => {
      el.textContent = 'Question ' + (idx + 1) + ' of ' + total;
    });
  }
  const progressBar = q('#progressBar');
  const backBtn = q('#backBtn');
  const popupOverlay = q('#popupOverlay');
  const popupText = q('#popupText');
  const popupYes = q('#popupYes');
  const popupNo = q('#popupNo');
  const skipQuiz = q('#skipQuiz');

  const LP_URL = "https:\/\/flyhugz.com\/products\/the-original-flyhugz-travel-pillow-2026";

  // ─────────── STATE ───────────
  const answers = {};
  let currentType = 0;
  let isTransitioning = false;

  // Restore from localStorage if present
  try {
    const saved = JSON.parse(localStorage.getItem('fh_quiz_answers') || '{}');
    Object.assign(answers, saved);
  } catch(e) {}

  // ─────────── TRAVELER TYPE PICKER (Q0) ───────────
  qa('.opt.gender-pick').forEach(btn => {
    btn.addEventListener('click', function() {
      if (isTransitioning) return;
      isTransitioning = true;
      const traveler = this.dataset.ans;
      answers.traveler = traveler;
      try { localStorage.setItem('fh_quiz_answers', JSON.stringify(answers)); } catch(e) {}
      this.classList.add('selected');
      setTimeout(() => {
        isTransitioning = false;
        next();
      }, 320);
    });
  });

  // ─────────── PROGRESS ───────────
  function updateProgress() {
    const pct = Math.max(6, Math.round((currentType - 1) / (totalSections - 1) * 100));
    progressBar.style.width = pct + '%';
  }

  // ─────────── NAV ───────────
  function showSection(num) {
    sections.forEach(s => {
      const t = parseInt(s.dataset.type, 10);
      s.classList.toggle('visible', t === num);
    });
    currentType = num;
    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onSectionEnter(num);
  }

  function next() {
    let n = currentType + 1;
    while (n < totalSections && !isSectionActive(n)) n++;
    if (n >= totalSections) return;
    showSection(n);
  }
  function prev() {
    let n = currentType - 1;
    while (n >= 0 && !isSectionActive(n)) n--;
    if (n < 0) return;
    showSection(n);
  }

  backBtn.addEventListener('click', prev);
  if (skipQuiz) {
    skipQuiz.addEventListener('click', e => {
      e.preventDefault();
      window.location.href = LP_URL;
    });
  }

  // ─────────── SAVE ANSWER ───────────
  function saveAnswer(type, value) {
    answers['q' + type] = value;
    try { localStorage.setItem('fh_quiz_answers', JSON.stringify(answers)); } catch(e) {}
  }

  // ─────────── SINGLE SELECT ───────────
  qa('.opt.single').forEach(btn => {
    btn.addEventListener('click', function() {
      if (isTransitioning) return;
      isTransitioning = true;
      const section = this.closest('section.q');
      const type = parseInt(section.dataset.type, 10);
      const ans = this.dataset.ans;
      section.querySelectorAll('.opt').forEach(o => o.classList.remove('selected'));
      this.classList.add('selected');
      saveAnswer(type, ans);
      setTimeout(() => {
        isTransitioning = false;
        next();
      }, 320);
    });
  });

  // ─────────── MULTI SELECT ───────────
  qa('section.q').forEach(section => {
    const multiBtns = section.querySelectorAll('.opt.multi');
    const continueBtn = section.querySelector('.continue-multi');
    if (!multiBtns.length || !continueBtn) return;

    multiBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        this.classList.toggle('selected');
        const anySelected = section.querySelectorAll('.opt.multi.selected').length > 0;
        continueBtn.disabled = !anySelected;
      });
    });

    continueBtn.addEventListener('click', function() {
      if (isTransitioning) return;
      if (this.disabled) return;
      const type = parseInt(section.dataset.type, 10);
      const selected = Array.from(section.querySelectorAll('.opt.multi.selected'))
        .map(b => b.dataset.ans);
      if (selected.length === 0) return;
      isTransitioning = true;
      saveAnswer(type, selected);
      setTimeout(() => {
        isTransitioning = false;
        next();
      }, 200);
    });
  });

  // ─────────── SINGLE CONTINUE (interstitials) ───────────
  qa('.btn.single-continue').forEach(btn => {
    btn.addEventListener('click', function() {
      if (isTransitioning) return;
      isTransitioning = true;
      const section = this.closest('section.q');
      const type = parseInt(section.dataset.type, 10);
      saveAnswer(type, this.dataset.ans || 'continue');
      setTimeout(() => {
        isTransitioning = false;
        if (this.classList.contains('last-q')) {
          startLoadingSequence();
        }
        next();
      }, 200);
    });
  });

  // ─────────── ON SECTION ENTER ───────────
  function onSectionEnter(num) {
    updateQuestionCounter(num);
    // Animate personalized transformation cards
    if (num === 16) {
      renderTransformations();
      setTimeout(() => {
        var tl = q('#transformList');
        if (tl) tl.classList.add('tx-active');
      }, 200);
    }
    // Start loading sequence
    if (num === 17) {
      startLoadingSequence();
    }
    // Animate social proof count-up
    if (num === 7) {
      const spNum = q('#spNum');
      if (spNum && !spNum.dataset.animated) {
        spNum.dataset.animated = '1';
        const target = 1586450;
        const duration = 1600;
        const start = performance.now();
        const tick = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          const value = Math.floor(target * eased);
          spNum.textContent = value.toLocaleString() + '+';
          if (t < 1) requestAnimationFrame(tick);
          else spNum.textContent = '1,586,450+';
        };
        requestAnimationFrame(tick);
      }
    }
    // Animate gauge dot + set profile face
    if (num === 15) {
      const dz = computeDiscomfort(answers);
      // Level pill text + color (red High / amber-orange Moderate / green-ish Mild)
      const pill = q('#levelPill');
      if (pill) {
        pill.textContent = dz.level;
        const pillColors = {
          High:     { bg: 'var(--red-soft)',   fg: 'var(--red)' },
          Moderate: { bg: '#FFEBD6',           fg: '#C2660A' },
          Mild:     { bg: 'var(--green-soft)', fg: 'var(--green-deep)' }
        }[dz.level];
        if (pillColors) { pill.style.background = pillColors.bg; pill.style.color = pillColors.fg; }
      }
      // Verdict heading + paragraph
      const vHead = q('#verdictHead');
      if (vHead) vHead.textContent = dz.level.toUpperCase() + ' discomfort';
      const vText = q('#verdictText');
      if (vText) vText.textContent = dz.verdict;
      // 4 diagnostic tiles (Main trigger / Comfort upgrade / Sleep impact / Travel readiness)
      for (let i = 0; i < 4; i++) {
        const tile = q('#dxTile' + i);
        if (tile) tile.textContent = dz.tiles[i];
      }
      // Animate gauge dot to computed pct
      const dot = q('#gaugeDot');
      const tip = q('#gaugeTip');
      if (dot && tip) {
        dot.style.left = '20%';
        tip.style.left = '20%';
        setTimeout(() => {
          dot.style.left = dz.pct + '%';
          tip.style.left = dz.pct + '%';
        }, 200);
      }
      const faceImg = q('#ppFace');
      if (faceImg) {
        faceImg.src = 'https://cdn.shopify.com/s/files/1/1005/5368/7319/files/008_b365f9a0-1b9b-4e51-91a5-6cc85094db8c.png?v=1787266808&width=700';
      }
      // Build matched-products list from pains
      renderMatchedProducts();
    }
  }

  // ─────────── MATCHED PRODUCTS RENDERER ───────────
  const PRODUCT_MAP = {
    'travel-pillow': {
      name: 'FlyHugz® Travel Pillow',
      tag: 'Your match',
      img: 'https://cdn.shopify.com/s/files/1/1005/5368/7319/files/2cb4fb748903.png?v=1788289108',
      desc: '360° memory-foam support. No more head bobbing or stiff neck.'
    },
    'sleep-mask': {
      name: 'FlyHugz® Sleep Mask',
      tag: 'FREE with Bundle 2+',
      img: 'https://cdn.shopify.com/s/files/1/0748/2156/6647/files/3e414d3dcdc8.png?v=1788289143',
      desc: '100% blackout. Cabin lights and sunrise, gone.'
    },
    'earplugs': {
      name: 'FlyHugz® Travel Earplugs',
      tag: 'FREE with Bundle 2+',
      img: 'https://cdn.shopify.com/s/files/1/1005/5368/7319/files/a07c10f0690a.png?v=1788289136',
      desc: 'Up to 32 dB noise reduction. Engine drone and chatter, silenced.'
    },
    'anti-theft': {
      name: 'FlyHugz® Anti-Theft Bag',
      tag: 'FREE with Bundle 2+',
      img: 'https://cdn.shopify.com/s/files/1/0748/2156/6647/files/6001475bf3ce.png?v=1788289123',
      desc: 'Slash-proof, RFID-blocking. Passport, phone & cash, locked down.'
    },
    'elastic-cover': {
      name: 'FlyHugz® Elastic Cover',
      tag: 'FREE with Bundle 2+',
      img: 'https://cdn.shopify.com/s/files/1/1005/5368/7319/files/70c44f7d91e3.jpg?v=1788289130',
      desc: 'Quick-swap, machine-washable. Fresh pillow every trip.'
    }
  };

  function getMatchedProducts() {
    const pains = Array.isArray(answers.q2) ? answers.q2 : [];
    const set = new Set(['travel-pillow']); // pillow always
    if (pains.includes('light')) set.add('sleep-mask');
    if (pains.includes('noise')) set.add('earplugs');
    if (pains.includes('theft')) set.add('anti-theft');
    if (pains.includes('hygiene')) set.add('elastic-cover');
    if (pains.includes('no-sleep') || pains.includes('exhausted')) {
      set.add('sleep-mask'); set.add('earplugs');
    }
    if (pains.includes('neck-pain') || pains.includes('ushape')) {
      set.add('elastic-cover'); // pillow hygiene partner
    }
    return Array.from(set).map(k => PRODUCT_MAP[k]).filter(Boolean);
  }

  function computeDiscomfort(a){
    var pains = Array.isArray(a.q2) ? a.q2 : (a.q2 ? [a.q2] : []);
    var s = pains.length*2;
    if(a.q4==='severe') s+=4; else if(a.q4==='moderate') s+=2; else if(a.q4==='mild') s+=1;
    if(a.q5) s+=3;
    if(a.q1==='weekly') s+=3; else if(a.q1==='monthly') s+=2; else if(a.q1==='yearly'||a.q1==='planning') s+=1;
    if(a.q8==='long'||a.q8==='multileg') s+=2; else if(a.q8==='mid') s+=1;
    if(a.q12==='dread') s+=3; else if(a.q12==='braced') s+=2; else if(a.q12==='checklist') s+=1;
    if(a.q11==='paranoid') s+=2; else if(a.q11==='cautious'||a.q11==='rfid-only') s+=1;
    var pct = Math.min(92, Math.max(30, Math.round(28 + s*2.2)));
    var level = pct>=75 ? 'High' : (pct>=52 ? 'Moderate' : 'Mild');
    var data = {
      High:     {verdict:"HIGH discomfort — you're losing sleep, comfort & confidence on every trip. Your setup forces your neck forward, lets light & noise wreck your rest, and leaves your gear exposed. The right kit fixes all of it.", tiles:["Poor neck support","Instant & major","Huge","Low"]},
      Moderate: {verdict:"MODERATE discomfort — travel takes a real toll on your comfort and sleep, especially on longer trips. Your current setup is holding you back. The right kit makes a noticeable difference.", tiles:["Neck & sleep strain","Noticeable","Significant","Medium"]},
      Mild:     {verdict:"MILD discomfort — you're doing okay, but there's clear room to travel more comfortably. A few smart upgrades will make every trip better and your arrivals fresher.", tiles:["Minor discomfort","A welcome boost","Moderate","Good"]}
    }[level];
    return {score:s, pct:pct, level:level, verdict:data.verdict, tiles:data.tiles, profile:level.toLowerCase()+'-discomfort'};
  }

  // ─────────── PERSONALIZED TRANSFORMATIONS ───────────
  const TRANSFORM_MAP = {
    'neck-pain':  { icon: '🧠', title: 'Neck pain on flights',       before: 'Stiff & sore for days after every trip',     after: '360° memory foam — zero pain on arrival',         product: 'travel-pillow' },
    'ushape':     { icon: '🌀', title: 'U-shape pillows failing you', before: 'Head still falls forward, useless support',  after: 'Velcro 2.0 locks your head in place',              product: 'travel-pillow' },
    'no-sleep':   { icon: '😴', title: "Can't sleep on transit",      before: 'Head-bobs & broken sleep the whole trip',    after: 'Deep sleep in minutes, even in economy',           product: 'travel-pillow' },
    'light':      { icon: '🌙', title: 'Light killing your sleep',    before: 'Cabin lights & sunrise wreck every doze',    after: '100% blackout mask — total darkness',              product: 'sleep-mask' },
    'noise':      { icon: '🔇', title: 'Engine noise & chatter',      before: 'Drone & crying kids steal your rest',        after: 'Up to 32 dB noise reduction, silence restored',    product: 'earplugs' },
    'theft':      { icon: '🛡️', title: 'Theft anxiety in crowds',     before: 'Constantly checking pockets in markets',     after: 'Slash-proof, RFID-blocked, locked down',           product: 'anti-theft' },
    'exhausted':  { icon: '⚡', title: 'Arriving exhausted',           before: 'Lose Day 1 of every trip recovering',        after: 'Land refreshed, ready to explore',                 product: 'travel-pillow' },
    'hygiene':    { icon: '🧼', title: 'Gross travel pillow',          before: 'Sweat & oils build up, no way to clean',     after: 'Quick-swap cover, machine washable',               product: 'elastic-cover' }
  };

  function renderTransformations() {
    const wrap = q('#transformList');
    if (!wrap) return;
    const pains = Array.isArray(answers.q2) ? answers.q2 : [];
    let items = pains.map(p => TRANSFORM_MAP[p]).filter(Boolean);
    // Fallback: if somehow empty, show top 3 universal
    if (!items.length) items = ['neck-pain','no-sleep','exhausted'].map(p => TRANSFORM_MAP[p]);
    wrap.innerHTML = items.map((t, i) => {
      const prod = PRODUCT_MAP[t.product] || PRODUCT_MAP['travel-pillow'];
      return `
        <div class="tx-card" style="--i:${i}">
          <div class="tx-head">
            <span class="tx-icon">${t.icon}</span>
            <div class="tx-title">${t.title}</div>
            <div class="tx-prod">
              <img src="${prod.img}" alt="${prod.name}">
              <span>${prod.name.replace('FlyHugz® ','')}</span>
            </div>
          </div>
          <div class="tx-body">
            <div class="tx-side tx-now">
              <div class="tx-tag">Now</div>
              <p>${t.before}</p>
            </div>
            <div class="tx-arrow">→</div>
            <div class="tx-side tx-fix">
              <div class="tx-tag">With FlyHugz®</div>
              <p>${t.after}</p>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function renderMatchedProducts() {
    const wrap = q('#matchedProducts');
    if (!wrap) return;
    const items = getMatchedProducts();
    wrap.innerHTML = items.map(p => `
      <div class="match-card">
        <img src="${p.img}" alt="${p.name}">
        <div class="match-body">
          <small>${p.tag}</small>
          <strong>${p.name}</strong>
          <p>${p.desc}</p>
        </div>
      </div>
    `).join('');
  }

  // ─────────── LOADING SEQUENCE ───────────
  let loadingStarted = false;
  const popupQueue = [
    { idx: 0, text: 'Are you ready to sleep on flights, instead of suffering through them?' },
    { idx: 1, text: 'Did you know FlyHugz® was featured on CBS & Inside Edition?' },
    { idx: 2, text: 'Would you like your FREE bonus gifts unlocked at checkout?' }
  ];

  function startLoadingSequence() {
    if (loadingStarted) return;
    loadingStarted = true;
    runLoadingBar(0);
  }

  function runLoadingBar(idx) {
    if (idx >= 3) {
      // Done with all 3
      q('#submitBtn').style.display = 'block';
      return;
    }
    const lr = q('#lr' + (idx + 1));
    lr.classList.remove('idle');
    const fill = lr.querySelector('.loading-fill');
    const pctEl = lr.querySelector('.pct');
    let pct = 0;
    let popupShown = false;
    const interval = setInterval(() => {
      pct += 2;
      if (pct === 50 && !popupShown && popupQueue[idx]) {
        popupShown = true;
        clearInterval(interval);
        showPopup(popupQueue[idx].text, () => {
          // resume
          const resumeInt = setInterval(() => {
            pct += 2;
            if (pct >= 100) {
              pct = 100;
              fill.style.width = '100%';
              pctEl.textContent = '100%';
              clearInterval(resumeInt);
              lr.classList.add('done');
              setTimeout(() => runLoadingBar(idx + 1), 500);
              return;
            }
            fill.style.width = pct + '%';
            pctEl.textContent = pct + '%';
          }, 70);
        });
        return;
      }
      if (pct >= 100) {
        pct = 100;
        fill.style.width = '100%';
        pctEl.textContent = '100%';
        clearInterval(interval);
        lr.classList.add('done');
        setTimeout(() => runLoadingBar(idx + 1), 500);
        return;
      }
      fill.style.width = pct + '%';
      pctEl.textContent = pct + '%';
    }, 70);
  }

  // ─────────── POPUP ───────────
  let popupCallback = null;
  function showPopup(text, callback) {
    popupText.textContent = text;
    popupCallback = callback;
    popupOverlay.classList.add('show');
  }
  function closePopup() {
    popupOverlay.classList.remove('show');
    const cb = popupCallback;
    popupCallback = null;
    if (cb) cb();
  }
  popupYes.addEventListener('click', closePopup);
  popupNo.addEventListener('click', closePopup);

  // ─────────── SUBMIT ───────────
  q('#submitBtn').addEventListener('click', function() {
    // Build URL with quiz answers as query params for personalization on LP
    const params = new URLSearchParams();
    Object.keys(answers).forEach(k => {
      const v = Array.isArray(answers[k]) ? answers[k].join(',') : answers[k];
      params.set(k, v);
    });
    params.set('source', 'quiz');
    params.set('profile', computeDiscomfort(answers).profile);
    const matches = getMatchedProducts().map(p => p.name.replace(/^FlyHugz® /,'')).join(',');
    params.set('matches', matches);
    const target = LP_URL + '?' + params.toString();
    window.location.href = target;
  });

  // ─────────── INIT ───────────
  updateProgress();
})();
